import { CommonHttpHelper, NO_DATA_MESSAGE } from '../../../../utils/HttpHelper';

const GetOrgUnitAthletesData = (orgUnitIds, state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    let newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    const map = orgUnitIds.map(x => { return { orgUnitId: x }; });
    const stringOrgUnitIds = JSON.stringify(map);

    const orgUnitIdsForUrl = stringOrgUnitIds ? encodeURIComponent(stringOrgUnitIds) : 'NaN';
    const url = `/OrgUnit/Athletes?orgUnits=${orgUnitIdsForUrl}`;
    CommonHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          newState = {
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            message: ''
          };
          setState(newState);
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

export default GetOrgUnitAthletesData;

